import { BookkeepingItem } from '@features/reconciliation/types/bookkeepingItem'

import { Side } from '../../../../../enums/side'

export const getAmountBySide = (item: BookkeepingItem): number => {
  // Debit = incoming (positive), Credit = outgoing (negative)
  return item.side === Side.Debit ? item.amount : -item.amount
}
